import { FormControl, Validators } from '@angular/forms';
import { FormConfig } from 'ngx-eo-web-components';

export const authFormConfig: FormConfig = new FormConfig({
  config: [
    {
      name: 'username',
      control: new FormControl('', [Validators.required]),
      errors: {
        required: 'Το όνομα χρήστη είναι υποχρεωτικό',
      },
    },
    {
      name: 'password',
      control: new FormControl('', [Validators.required]),
      errors: {
        required: 'Ο κωδικός είναι υποχρεωτικός',
      },
    },
  ],
});
